import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { InventoryItemForm } from "@/pages/Moves/components/InventoryTable";
import { cn } from "@/lib/utils";

type InventoryToolbarProps = {
  searchTerm: string;
  inventory: InventoryItemForm[];
  onSearchChange: (value: string) => void;
  onSave: () => void;
  buttonText?: string;
  onCancel?: () => void;
  showSummary?: boolean;
};

const InventoryToolbar = ({
  searchTerm,
  inventory,
  onSearchChange,
  onSave,
  buttonText = "Save Changes",
  onCancel,
  showSummary = true,
}: InventoryToolbarProps) => {
  const numberOfItems = inventory.filter((item) => item.quantity > 0).length;

  const totalVolume = inventory.reduce(
    (sum, item) => sum + (item.total_volume_cuft || 0),
    0
  );
  const totalWeight = inventory.reduce(
    (sum, item) => sum + (item.total_weight_lbs || 0),
    0
  );

  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-2">
        <div className="relative">
          <Input
            placeholder="Find item by name"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-48 pr-8"
          />
          {searchTerm && (
            <button
              onClick={() => onSearchChange("")}
              className="absolute right-2 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              aria-label="Clear search"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          )}
        </div>
      </div>
      <div
        className={cn(
          "flex items-center gap-6 font-semibold text-lg",
          !showSummary && "hidden"
        )}
      >
        <span>{numberOfItems} item(s)</span>
        <span>{totalVolume.toFixed(2)} cuft</span>
        <span>{totalWeight.toFixed(2)} lbs</span>
        <Button onClick={onSave} variant="default">
          {buttonText}
        </Button>
        {onCancel && (
          <Button onClick={onCancel} variant="outline">
            Cancel
          </Button>
        )}
      </div>
    </div>
  );
};

export default InventoryToolbar;
